import { InstallmentProviderType, PaymentMethodKind, PaymentServiceType } from '../../../enums';
export default class PaymentMethodInfo {
    code: string;
    kind: PaymentMethodKind;
    service: PaymentServiceType;
    isInstallment: boolean;
    provider: InstallmentProviderType;
    termMonths: number | null;
    cardFirstSixDigits: string | null;
    cardLastFourDigits: string | null;
    payFormDomain: string | null;
    acquiring: string | null;
    externalUrl: string | null;
    payerEmail: string | null;
    payerPhone: string | null;
    payDate: string | null;
    paySum: string | null;

    constructor(info: Partial<PaymentMethodInfo>) {
        this.code = info.code ?? '';
        this.kind = info.kind ?? PaymentMethodKind.Unknown;
        this.service = info.service ?? PaymentServiceType.None;
        this.isInstallment = info.isInstallment ?? false;
        this.provider = info.provider ?? InstallmentProviderType.Unknown;
        this.termMonths = info.termMonths ?? null;
        this.cardFirstSixDigits = info.cardFirstSixDigits ?? null;
        this.cardLastFourDigits = info.cardLastFourDigits ?? null;
        this.payFormDomain = info.payFormDomain ?? null;
        this.acquiring = info.acquiring ?? null;
        this.externalUrl = info.externalUrl ?? null;
        this.payerEmail = info.payerEmail ?? null;
        this.payerPhone = info.payerPhone ?? null;
        this.payDate = info.payDate ?? null;
        this.paySum = info.paySum ?? null;
    }

    get hasCard() {
        return !!this.cardLastFourDigits;
    }

    get hasKnownProvider() {
        return this.provider !== InstallmentProviderType.Unknown;
    }

    get hasPayer() {
        return !!this.payerEmail || !!this.payerPhone;
    }

    static parse(json: string | null | undefined): PaymentMethodInfo | null {
        if (!json) return null;
        try {
            return new PaymentMethodInfo(JSON.parse(json));
        } catch {
            return null;
        }
    }
}
